import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import React, { useState } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import { ADD_NEW_DICOM_TAG } from "../../appConstants";
import axiosInstance from "../AxiosInstance/AxiosInstance";
import "./Modal.css";

const AddCutomProtocol = (props) => {
  const [id, setID] = useState("");
  const [desc, setdesc] = useState("");
  const [error, seterror] = useState(false);
  const [dataType, setDataType] = useState("");

  let DataTypeOptions = [
    { id: 1, value: "str", label: "String" },
    { id: 1, value: "numeric", label: "Numeric" },
  ];

  const datatypeChange = (e) => {
    setDataType(e);
  };
  const handleclick = () => {
    if (!id || !desc || !dataType) {
      seterror(true);
      setTimeout(() => {
        seterror(false);
      }, 2000);
      return;
    }
    const fetchData = async () => {
      const filterobj = {
        tag_id: id,
        tag_description: desc,
        tag_type: dataType.value,
      };

      try {
        const response = await axiosInstance.post(
          `${ADD_NEW_DICOM_TAG}`,
          filterobj,
          {
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          }
        );

        if (response.data.success) {
          toast.success(`${response.data.message}`, {
            position: toast.POSITION.BOTTOM_CENTER,
          });
        } else {
          toast.error(`Error: ${response.data.message}`, {
            position: toast.POSITION.BOTTOM_CENTER,
          });
        }
      } catch (error) {
        toast.error(`Error: ${error.message}`, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    };
    fetchData();
  };

  const modalStyles = {
    color: "white",
    fontWeight: "bold",
    position: "absolute",
    top: 0,
    right: 0,
    width: "30%",
    padding: "2rem",
    height: "100vh",
    backdropFilter: "blur(14.5px)",
    background: "transparent",
    boxShadow: " 0 0 6px 0 rgba(149,149,149,0.5)",
  };
  return (
    <div>
      <Modal onClose={props.handleClose} open={props.ModalState}>
        <Box sx={modalStyles}>
          <div className="d-flex justify-content-between ">
            <div className="h5 font-weight-bold  mt-2">Add Custom Tag</div>
            <div className=" ">
              <IconButton
                className="text-light"
                onClick={props.handleClose}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            </div>
          </div>
          <div>
            <div className="sort_search_header_field mt-2">Tag ID*</div>
            <div>
              <input
                required
                id="name"
                label="Tag ID"
                onChange={(e) => setID(e.target.value)}
                className="text-input-modal mt-1"
                placeholder="Tag ID example:(0023,1257)"
              />
              {!id && error && <span className="errorStyles">ID Required</span>}
            </div>
            <div className="sort_search_header_field  mt-4">
              Tag Description*
            </div>
            <div className="mb-2">
              <input
                required
                id="name"
                label="Tag Description"
                className="text-input-modal mt-1"
                placeholder="Tag Description"
                onChange={(e) => setdesc(e.target.value)}
              />

              {!desc && error && (
                <span className="errorStyles">Description Required</span>
              )}
            </div>

            <div className="sort_search_header_field mt-4">Tag Data Type*</div>
            <Select
              className="mb-2"
              theme={(theme) => ({
                ...theme,
                borderRadius: "5px",
                colors: {
                  ...theme.colors,
                  primary75: "white",
                  primary50: "white",
                  primary25: "white",
                  danger: "#DE350B",
                  dangerLight: "#FFBDAD",
                  neutral0: "black",
                  neutral5: "hsl(0, 0%, 95%)",
                  neutral10: "hsl(0, 0%, 90%)",
                  neutral30: "hsl(0, 0%, 70%)",
                  neutral40: "hsl(0, 0%, 60%)",
                  neutral50: "hsl(0, 0%, 50%)",
                  neutral60: "hsl(0, 0%, 40%)",
                  neutral70: "hsl(0, 0%, 30%)",
                  neutral80: "white",
                  neutral90: "hsl(0, 0%, 10%)",
                },
              })}
              styles={{
                control: (provided) => ({
                  ...provided,
                  width: "100%",
                  backgroundColor: "black",
                  color: "white",
                  border: "1px solid #0f9077",
                  boxShadow: "0 0 1px rgba(0, 0, 0, 0)",
                  "&:hover": {
                    border: "1px solid #0f9077",
                  },
                }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: "black",
                  color: "white",
                }),
                singleValue: (provided) => ({
                  ...provided,
                  fontWeight: "normal",
                }),
                placeholder: (provided) => ({
                  ...provided,
                  fontWeight: "normal",
                }),
                clearIndicator: (provided) => ({
                  ...provided,
                  cursor: "pointer",
                }),
              }}
              isClearable={true}
              placeholder="Select Data Type"
              name="Tag Data Type"
              options={DataTypeOptions}
              onChange={datatypeChange}
            />
            {!dataType && error && (
              <span className="errorStyles">Data Type Required</span>
            )}
          </div>
          <button
            type="button"
            className="btn mr-4 shadow btn-dataset"
            style={{
              width: 101,
              color: "black",
              backgroundColor: "#0FC4A0",
              position: "relative",
              top: 28,
              fontWeight: "bold",
              cursor: "pointer",
              fontFamily: "Montserrat",
            }}
            onClick={() => handleclick()}
          >
            ADD
          </button>
        </Box>
      </Modal>
    </div>
  );
};

export default AddCutomProtocol;
